import React, { Fragment, lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import AuthRoutes from "../Authentication/routes";
import AdminRoutes from "../portals/admin/routes";
import CustomerRoutes from "../portals/customer/routes";
import SupplierRoutes from "../portals/supplier/routes";

const HelpCenter = lazy(() => import("../help/HelpCenter"));
const PartnerPage = lazy(() => import("../partner/PartnerPage"));

export default function AppRouters() {
  return (
    <>
      <AuthRoutes />
      <AdminRoutes />
      <CustomerRoutes />
      <SupplierRoutes />
      <Routes>
        <Route
          path="/help/*"
          element={
            <Suspense fallback={null}>
              <HelpCenter />
            </Suspense>
          }
        />
        <Route
          path="/partner/:token"
          element={
            <Suspense fallback={null}>
              <PartnerPage />
            </Suspense>
          }
        />
      </Routes>
    </>
  );
}
